import React, { useState, useRef, useEffect } from "react";
import styled, { css } from "styled-components";

import AppWindow from "./window-styled-container";

const Container = styled.div`
    position: relative;
    padding: 0 1rem;
    z-index: 0;

    width: 400px;
    height: 350px;
`;

const Backplate = styled(AppWindow)`
    width: 100%;
    height: 75%;
    position: absolute;
    bottom: 0;
    left: 0;
    margin: 0;
    z-index: -1;
    background: linear-gradient(var(--kpum-lightorange) 0%, var(--kpum-orange) 200%);

    /* For the loading spinner */
    align-items: center;
    justify-content: center;
`;

// So that the image can slide out from the bottom without overflowing / being visible outside the container
const ImageWrapper = styled.div`
    overflow: hidden;
    width: 100%;
    height: 100%;
`;

const Image = styled.img`
    height: 100%;
    margin: 0 auto;
    display: block;
    filter: drop-shadow(0 0 5px rgb(0 0 0 / 0.5));

    /* FIXME */
    width: 100%;
    object-fit: contain;
    object-position: bottom;

    ${props => props.animateOnEntrance ? css`
        animation: move-up 1s;
        @keyframes move-up {
            from { transform: translateY(100%);}
        }
    ` : css`
        animation: fade-up 0.4s;
        @keyframes fade-up {
            from {
                transform: translateY(20%);
                opacity: 0;
            }
        }
    `}

    &.loading {
        animation-play-state: paused;
    }
`;

const LoadingCircle = styled.div`
    width: 2em;
    height: 2em;
    border-radius: 50%;

    border: 0.25em solid white;
    border-color: white white white transparent;
    opacity: 0.75;

    animation: spinnyboi 1s linear infinite;
    @keyframes spinnyboi {
        from { transform: rotate(0deg); }
        to { transform: rotate(360deg); }
    }

    &:not(.visible) {
        display: none;
    }
`;

const CapresmaImage = ({ noUrut, style, className, animateOnEntrance }) => {
    const [imageHasLoaded, imageSetLoaded] = useState(false);
    const imgRef = useRef(null);

    // Workaround for image not loading on initial page load (i.e. not on route change)
    useEffect(() => {
        if (imgRef.current?.complete && !imageHasLoaded) {
            imageSetLoaded(true);
            console.log("Image already loaded; setting state manually...");
        }
    });

    return (
        <Container style={style} className={className}>
            <ImageWrapper>
                <Image
                    src={require(`../assets/capresma/${noUrut}.png`)}
                    alt={`Capresma nomor urut ${noUrut}`}
                    onLoad={() => imageSetLoaded(true)}
                    ref={imgRef}
                    className={imageHasLoaded ? null : "loading"}
                    animateOnEntrance={animateOnEntrance} />
            </ImageWrapper>
            <Backplate>
                <LoadingCircle className={imageHasLoaded ? null : "visible"} />
            </Backplate>
        </Container>
    )
};

export default CapresmaImage;